import Version from './version';
import parseParams from './params';
import parseOS from './os';
import parseBrowser from './browser';
import parseAliApp from './aliapp';
import parseThirdApp from './thirdapp';

const parseEnv = (ua, search) => {
  const env = {};

  env.params = parseParams(search);
  env.os = parseOS(ua);
  env.browser = parseBrowser(ua);
  env.aliapp = parseAliApp(ua);
  env.thirdapp = parseThirdApp(ua);

  return env;
};

export {
  parseEnv,
  parseParams,
  parseOS,
  parseAliApp,
  parseBrowser,
  parseThirdApp,
  Version,
};
